module.exports = __webpack_public_path__ + "d538258a6e5d2e8b62063224e12ba619.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/empty-state/insights-group.png
// module id = 1555
// module chunks = 0